import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Button from '../components/Button';
import usePageMetadata from '../hooks/usePageMetadata';
import * as authApi from '../api/endpoints/auth';
import { authSection, btnLg, btnPrimary, containerForm, inputClass, labelClass } from '../styles/ui';

const EmailVerificationPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [code, setCode] = useState('');
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState('We sent a verification code to your email.');
  const [submitting, setSubmitting] = useState(false);
  const [resending, setResending] = useState(false);

  usePageMetadata({
    title: 'Verify Email | Fresh & Homely',
    description: 'Confirm your email address to activate your Fresh & Homely account.',
    canonicalPath: '/verify-email',
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await authApi.confirmEmailVerification(email.trim(), code.trim());
      navigate('/login');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleResend = async () => {
    setError(null);
    setResending(true);
    try {
      await authApi.requestEmailVerification(email.trim());
      setNotice('A new code has been sent to your email.');
    } catch (err) {
      setError(err.message);
    } finally {
      setResending(false);
    }
  };

  return (
    <>
      <Navbar />
      <section className={authSection}>
        <div className={`${containerForm} w-full`}>
          <div className="bg-white/90 backdrop-blur-sm rounded-4xl border border-emerald-50 p-8 shadow-floating">
            <h1 className="serif text-3xl text-emerald-950 mb-2 text-center">Verify your email</h1>
            <p className="text-ink-secondary text-center mb-8">{notice}</p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className={labelClass}>Email</label>
                <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} />
              </div>
              <div>
                <label htmlFor="code" className={labelClass}>Verification code</label>
                <input id="code" required value={code} onChange={(e) => setCode(e.target.value)} className={inputClass} />
              </div>

              {error && <p className="text-sm text-red-600">{error}</p>}

              <button
                type="submit"
                disabled={submitting}
                className={`w-full ${btnPrimary} ${btnLg}`}
              >
                {submitting ? 'Verifying...' : 'Verify Email'}
              </button>
            </form>

            <Button
              variant="ghost"
              onClick={handleResend}
              disabled={!email}
              loading={resending}
              loadingLabel="Sending..."
              className="mt-4 w-full text-sm"
            >
              Didn't get a code? Resend
            </Button>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default EmailVerificationPage;
